import { ReportData } from '../types/interfaces';
import { apiFetch } from './api';

export interface InventoryResponse {
  items: unknown[];
  totalPages: number;
}

export const fetchInventory = async () => {
  const response = await apiFetch('/api/inventory', {
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP error: ${response.status}`);
  }
  return response.json();
};

export const fetchVendors = async () => {
  const response = await apiFetch('/api/vendors', {
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP error: ${response.status}`);
  }
  return response.json();
};

export const fetchDailySummary = async () => {
  const response = await apiFetch('/api/reports/daily-summary', {
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP error: ${response.status}`);
  }
  return response.json();
};

export const fetchMonthlyReport = async (month: string): Promise<ReportData | null> => {
  try {
    const response = await apiFetch(`/api/report/monthly?month=${month}`, {
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch report: ${response.status}`);
    }
    return response.json();
  } catch (error) {
    console.error('[fetchMonthlyReport] Error:', error);
    return null;
  }
};

export const fetchDailyReport = async (date: string): Promise<ReportData | null> => {
  try {
    const response = await apiFetch(`/api/report/daily?date=${date}`, {
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch report: ${response.status}`);
    }
    return response.json();
  } catch (error) {
    console.error('[fetchDailyReport] Error:', error);
    return null;
  }
};
